<template>
  <div class="rk-tabs" :class="[shrink ? 'rk-tabs--shrink' : 'rk-tabs--spread', { 'rk-tabs--slider': slider }]">
    <div
      v-for="(item, index) in options"
      :key="index"
      class="rk-tabs__item"
      :class="{ 'rk-tabs__item--active': item.value === activeMap[0] }"
      @click.stop="changeActive(item)"
    >
      <span class="rk-tabs__item-label">{{ $t(item.label) }}</span>
      <div v-if="item.children" class="rk-tabs__children">
        <div
          v-for="subItem in item.children"
          :key="subItem.value"
          :class="['rk-tabs__children-item', { 'rk-tabs__children-item--active': subItem.value === activeMap[1] }]"
          @click.stop="changeActive(item, subItem)"
        >
          {{ $t(subItem.label) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RkTabs',
  model: {
    prop: 'activeName',
    event: 'click'
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    activeName: {
      required: true
    },
    shrink: {
      type: Boolean,
      default: false
    },
    slider: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    activeMap() {
      const activeName = this.activeName
      if (activeName instanceof Array) {
        return activeName
      } else {
        return [activeName, null]
      }
    }
  },
  methods: {
    changeActive(item, sub) {
      const activeName = sub ? [item.value, sub.value] : item.value
      if (JSON.stringify(activeName) === JSON.stringify(this.activeName)) return
      this.$emit('click', activeName)
      this.$emit('change', activeName)
    }
  }
}
</script>

<style lang="scss" scoped>
.rk-tabs {
  --rk-tabs-font-size: 16px;
  --rk-tabs-background-color: var(--bg-color-2);
  --rk-tabs-font-color: var(--font-color-3);
  --rk-tabs-padding: 0 var(--edge-padding);
  --rk-tabs-slider-color: var(--font-color-1);
  --rk-tabs-slider-width: 20px;

  --rk-tabs-item-padding: 13px 0;
  --rk-tabs-item-margin: 28px;
  --rk-tabs-item-background-color: var(--bg-color-2);
  --rk-tabs-item-border: 1px solid var(--border-color-1);
  --rk-tabs-item-border-radius: 5px;

  --rk-tabs-font-color-active: var(--font-color-1);
  --rk-tabs-item-background-color-active: var(--main-color-1);
  --rk-tabs-item-border-active: 1px solid var(--main-color-1);
  --rk-tabs-font-weight-active: 500;
}

.rk-tabs {
  position: sticky;
  overflow: scroll;
  top: 0;
  z-index: 100;
  display: flex;
  padding: var(--rk-tabs-padding);
  border-bottom: 1px solid var(--border-color-1);
  color: var(--rk-tabs-font-color);
  font-size: var(--rk-tabs-font-size);
  background: var(--rk-tabs-background-color);

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  .rk-tabs__item {
    position: relative;
    white-space: nowrap;
    cursor: pointer;
    padding: var(--rk-tabs-item-padding);

    &:not(:first-child) {
      margin-left: var(--rk-tabs-item-margin);
    }
    &:hover {
      .rk-tabs__children {
        display: block;
      }
    }
  }

  .rk-tabs__item-label {
    display: flex;
    justify-content: center;
  }

  .rk-tabs__item--active {
    .rk-tabs__item-label {
      color: var(--rk-tabs-font-color-active);
      font-weight: var(--rk-tabs-font-weight-active);
    }
  }

  &:not(.rk-tabs--slider) {
    .rk-tabs__item-label {
      border: var(--rk-tabs-item-border);
      border-radius: var(--rk-tabs-item-border-radius);
      background: var(--rk-tabs-item-background-color);
    }
    .rk-tabs__item--active {
      .rk-tabs__item-label {
        border: var(--rk-tabs-item-border-active);
        background: var(--rk-tabs-item-background-color-active);
      }
    }
  }
}

// 水平均分布局
.rk-tabs--spread {
  justify-content: space-between;
  &:not(.rk-tabs--slider) {
    .rk-tabs__item {
      flex: 1;
    }
  }
}

// 标签页形式
.rk-tabs--slider {
  .rk-tabs__item--active {
    .rk-tabs__item-label {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        width: 14px;
        height: 3px;
        bottom: 1px;
        right: -4px;
        background: var(--main-color-3);
      }
    }
  }
}

.rk-tabs__children {
  display: none;
  position: absolute;
  left: 0;
  top: 100%;
  border: 1px solid #f0f0f0;
  background: #fff;
  z-index: 9999;
  box-shadow: -1px 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  .rk-tabs__children-item {
    padding: 5px;
    white-space: nowrap;
    color: #627088;
    &.rk-tabs__children-item--active {
      background: rgba(247, 110, 82, 0.5);
    }
    &:not(.rk-tabs__children-item--active):hover {
      background: #f0f0f0;
    }
  }
}
</style>
